import React from 'react';
import office365Logo from './outlook365Logo.png';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

function Outlook365Logo({ ...props }) {
  const { tr } = useTranslation();
  return <img src={office365Logo} alt={tr('perform.logos.outlook_365.alt')} {...props} />;
}

export default Outlook365Logo;
